import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import { Reveal } from "../components/Reveal";
import Breadcrumbs from "../components/Breadcrumbs";
import { TOOLS } from "../lib/tools";

export default function Tools() {
  return (
    <div className="pt-28 md:pt-32">
      <SEO title="Numerology Tools" description="Explore Numoraa's free AI-powered numerology tools: Numerology Calculator, AI Palm Reading, Lo Shu Grid, Love Calculator and Personalized Report." path="/tools" />
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Tools", path: "/tools" }]} />
        <Reveal>
          <h1 className="mt-6 font-serif text-5xl sm:text-6xl md:text-7xl font-light tracking-tighter">
            Tools for the <span className="italic text-primary">curious</span>.
          </h1>
          <p className="mt-6 max-w-xl text-lg font-light text-muted-foreground">
            Five carefully crafted tools to reveal your numbers, balance your energies and spark a little wonder.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3 pb-24">
          {TOOLS.map((tool, i) => {
            const Icon = tool.icon;
            return (
              <Reveal key={tool.slug} delay={i * 0.07}>
                <Link
                  to={`/tools/${tool.slug}`}
                  data-testid={`tools-card-${tool.slug}`}
                  className="group flex h-full flex-col overflow-hidden rounded-3xl border border-border bg-card shadow-soft transition-all duration-500 hover:shadow-lift hover:-translate-y-1"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img src={tool.image} alt={tool.name} loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent" />
                    <span className="absolute top-4 left-4 flex h-11 w-11 items-center justify-center rounded-full bg-white/90">
                      <Icon className="h-5 w-5 text-primary" strokeWidth={1.6} />
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <p className="text-xs uppercase tracking-[0.2em] text-gold">{tool.tagline}</p>
                    <h2 className="mt-2 font-serif text-2xl">{tool.name}</h2>
                    <p className="mt-2 flex-1 text-sm text-muted-foreground leading-relaxed">{tool.description}</p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-sm text-primary">
                      Open tool <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  );
}
